import { inject, Injectable } from '@angular/core';
import { ApiGatewayService } from './api-gateway.service';
import { Observable } from 'rxjs';
import { AuthResponse, CheckAuthResponse, Credentials } from './models';
import { ProfileService } from './profile.service';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  private gateway: ApiGatewayService = inject(ApiGatewayService);

  isLoggedIn(): Observable<CheckAuthResponse> {
    return this.gateway.get<CheckAuthResponse>('/checkauth');
  }

  authenticate(username: string, password: string): Observable<AuthResponse> {
    const credentials: Credentials = {
      username: username,
      password_text: password,
    };

    return this.gateway.post<Credentials, AuthResponse>('/auth', credentials);
  }

  logout(): Observable<AuthResponse> {
    return this.gateway.post<any, AuthResponse>('/logout', undefined);
  }
}
